interface Array<T> {
  findRecursive(predicate: (value: T, index: number, obj: T[]) => boolean, childrenPropertyName: string): T | undefined;
  filterRecursive(predicate: (value: T, index: number, array: T[]) => any, childrenPropertyName: string): T[];
  flattenRecursive(propertyName: string): T[];
}

Array.prototype.findRecursive = function (predicate, childrenPropertyName) {
  if (!childrenPropertyName) {
    throw new Error('findRecursive requires parameter `childrenPropertyName`');
  }
  let array = [];
  array = this;
  const initialFind = array.find(predicate);
  const elementsWithChildren = array.filter(x => x[childrenPropertyName]);
  if (initialFind) {
    return initialFind;
  } else if (elementsWithChildren.length) {
    const childElements = [];
    elementsWithChildren.forEach(x => {
      childElements.push(...x[childrenPropertyName]);
    });
    return childElements.findRecursive(predicate, childrenPropertyName);
  } else {
    return undefined;
  }
};

Array.prototype.filterRecursive = function (predicate, childProperty) {
  const filterResults = [];
  const filterAndPushResults = (arrayToFilter) => {
    const elementsWithChildren = arrayToFilter.filter(x => x[childProperty]);
    const filtered = arrayToFilter.filter(predicate);
    filterResults.push(...filtered);
    if (elementsWithChildren.length) {
      const childElements = [];
      elementsWithChildren.forEach(x => {
        childElements.push(...x[childProperty]);
      });
      filterAndPushResults(childElements);
    }
  };
  filterAndPushResults(this);
  return filterResults;
};

Array.prototype.flattenRecursive = function (propertyName) {
  const results = [];
  const flattenAndPushResults = (arrayToFilter) => {
    const elementsWithChildren = arrayToFilter.filter(x => x[propertyName]);
    results.push(...elementsWithChildren);
    if (elementsWithChildren.length) {
      const childElements = [];
      elementsWithChildren.forEach(x => {
        childElements.push(...x[propertyName]);
      });
      flattenAndPushResults(childElements);
    }
  };
  flattenAndPushResults(this);
  return results;
};
